/**
 * Comutatorul ecranului de protocol (SP-03, pasul 4 din 4).
 *
 * OPRIT implicit, si citit o singura data, aici: `VITE_*` se inline-uieste la
 * BUILD, deci valoarea nu se schimba la runtime — un `if` imprastiat prin
 * componente ar sugera altceva.
 *
 * Cat timp e oprit, ruta nu se inregistreaza deloc (vezi `routes-provider`), si
 * nici legatura din `AccountWaitingPage` nu se randeaza — altfel ar fi un link
 * mort catre o ruta inexistenta. Acelasi tipar ca `video-flag.ts`.
 *
 * ⚠️ `src/vite-env.d.ts` declara sase variabile, dar `ImportMetaEnv` are
 * `[key: string]: any` — deci un typo intr-un nume `VITE_*` compileaza si devine
 * `undefined` la runtime. De-aia numele e scris o SINGURA data, aici.
 */
/* 🔴 Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste textual
   `import.meta.env.VITE_...` la build. La `video-flag.ts` prima versiune era
   `(import.meta as {...}).env?.VITE_...` — TypeScript multumit, dar inlocuirea nu
   se mai potriveste, deci in bundle ramane `undefined` si flagul e mereu oprit.
   Simptomul a fost o ruta care nu se inregistra si un redirect tacut la
   autentificare; numele variabilei nici nu aparea in bundle. */
export const PROTOCOL_DESCARCARE_ACTIV =
    String(import.meta.env.VITE_PROTOCOL_DESCARCARE ?? '').toLowerCase() === 'true';
